var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.875C14.625 7.0625 14.25 7.125 13.8125 7.1875C14.25 6.9375 14.5625 6.5625 14.6875 6.0625C14.3125 6.3125 13.875 6.4375 13.375 6.5625C13 6.1875 12.4375 5.9375 11.875 5.9375C10.5625 5.9375 9.5625 7.1875 9.875 8.4375C8.1875 8.375 6.6875 7.5625 5.625 6.3125C5.0625 7.25 5.375 8.4375 6.25 9.0625C5.9375 9.0625 5.625 8.9375 5.3125 8.8125C5.3125 9.75 6 10.625 6.9375 10.875C6.625 10.9375 6.3125 11 6 10.9375C6.25 11.75 7 12.375 7.9375 12.375C7.1875 12.9375 6.0625 13.25 5 13.125C5.9375 13.6875 7 14.0625 8.125 14.0625C11.9375 14.0625 14.0625 10.875 13.9375 7.9375C14.375 7.6875 14.75 7.3125 15 6.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.64d0aeef5623e8ce48809b72704c8f1d.svg";
export { ForwardRef as ReactComponent };